import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "exampleModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  key: 0,
  class: ""
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  class: "modal-body",
  style: {"text-align":"left","word-wrap":"break-word"}
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_watermark = _resolveComponent("el-watermark")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_component_el_watermark, {
        key: _ctx.name + '_' + _ctx.spa,
        content: _ctx.watermarkConfig.content,
        font: _ctx.watermarkConfig.font,
        "z-index": _ctx.watermarkConfig.zIndex,
        rotate: _ctx.watermarkConfig.rotate,
        gap: _ctx.watermarkConfig.gap,
        offset: _ctx.watermarkConfig.offset
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "modal-header" }, [
              _createElementVNode("h5", {
                class: "modal-title",
                id: "exampleModalLabel"
              }, "心得"),
              _createElementVNode("a", {
                class: "btn btn-outline-dark",
                href: "https://imgf.gg9453.com/images/body.jpg",
                target: "_blank",
                style: {"margin-left":"45%"}
              }, "身材參考圖"),
              _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              })
            ], -1)),
            (_ctx.pwShow)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _cache[2] || (_cache[2] = _createElementVNode("h6", { style: {"color":"red"} }, "密碼請洽幹部索取", -1)),
                    _cache[3] || (_cache[3] = _createTextVNode(" 請輸入密碼: ", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      style: {"width":"100px"},
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pwd) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.pwd]
                    ]),
                    _cache[4] || (_cache[4] = _createTextVNode(" ", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doCheck()))
                    }, " 確定 "),
                    _createElementVNode("p", {
                      class: "h6 text-danger",
                      innerHTML: _ctx.getResult
                    }, null, 8, _hoisted_5)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentData, (comment) => {
                return (_openBlock(), _createElementBlock("div", { key: comment }, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", { style: {"font-weight":"bold","font-size":"22px"} }, "年紀: ", -1)),
                  _createElementVNode("span", {
                    style: {"font-size":"20px","word-wrap":"break-word"},
                    innerHTML: comment.age
                  }, null, 8, _hoisted_7),
                  _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { style: {"font-weight":"bold","font-size":"22px"} }, "外型: ", -1)),
                  _createElementVNode("span", {
                    style: {"font-size":"20px","word-wrap":"break-word"},
                    innerHTML: comment.face
                  }, null, 8, _hoisted_8),
                  _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                  _cache[9] || (_cache[9] = _createElementVNode("span", { style: {"font-weight":"bold","font-size":"22px"} }, "身材: ", -1)),
                  _createElementVNode("span", {
                    style: {"font-size":"20px","word-wrap":"break-word"},
                    innerHTML: comment.body
                  }, null, 8, _hoisted_9),
                  _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
                  _cache[11] || (_cache[11] = _createElementVNode("span", { style: {"font-weight":"bold","font-size":"22px"} }, "胸: ", -1)),
                  _createElementVNode("span", {
                    style: {"font-size":"20px","word-wrap":"break-word"},
                    innerHTML: comment.cup
                  }, null, 8, _hoisted_10),
                  _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                  _cache[13] || (_cache[13] = _createElementVNode("span", { style: {"font-weight":"bold","font-size":"22px"} }, "膚質膚色: ", -1)),
                  _createElementVNode("span", {
                    style: {"font-size":"20px","word-wrap":"break-word"},
                    innerHTML: comment.skin
                  }, null, 8, _hoisted_11),
                  _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                  _cache[15] || (_cache[15] = _createElementVNode("span", { style: {"font-weight":"bold","font-size":"22px"} }, "音樂: ", -1)),
                  _createElementVNode("span", {
                    style: {"font-size":"20px","word-wrap":"break-word"},
                    innerHTML: comment.music
                  }, null, 8, _hoisted_12),
                  _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                  _cache[17] || (_cache[17] = _createElementVNode("span", { style: {"font-weight":"bold","font-size":"22px"} }, "體育: ", -1)),
                  _createElementVNode("span", {
                    style: {"font-size":"20px","word-wrap":"break-word"},
                    innerHTML: comment.sports
                  }, null, 8, _hoisted_13),
                  _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                  _cache[19] || (_cache[19] = _createElementVNode("span", { style: {"font-weight":"bold","font-size":"22px"} }, "尺度: ", -1)),
                  _createElementVNode("span", {
                    style: {"font-size":"20px","word-wrap":"break-word"},
                    innerHTML: comment.interactive
                  }, null, 8, _hoisted_14),
                  _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                  _cache[21] || (_cache[21] = _createElementVNode("span", { style: {"font-weight":"bold","font-size":"22px"} }, "心得: ", -1)),
                  _createElementVNode("span", {
                    style: {"font-size":"20px","word-wrap":"break-word"},
                    innerHTML: comment.comment
                  }, null, 8, _hoisted_15),
                  _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
                  _cache[23] || (_cache[23] = _createElementVNode("span", { style: {"font-weight":"bold","font-size":"22px"} }, "填寫者: ", -1)),
                  _createElementVNode("span", {
                    style: {"font-size":"20px","word-wrap":"break-word"},
                    innerHTML: comment.author
                  }, null, 8, _hoisted_16),
                  _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                  _cache[25] || (_cache[25] = _createElementVNode("span", { style: {"font-weight":"bold","font-size":"22px"} }, "填寫日期: ", -1)),
                  _createElementVNode("span", {
                    style: {"font-size":"20px","word-wrap":"break-word"},
                    innerHTML: comment.writeDate
                  }, null, 8, _hoisted_17),
                  _cache[26] || (_cache[26] = _createElementVNode("hr", null, null, -1))
                ]))
              }), 128)),
              _cache[27] || (_cache[27] = _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                "data-bs-dismiss": "modal"
              }, " 關閉 ", -1))
            ])
          ])
        ]),
        _: 1
      }, 8, ["content", "font", "z-index", "rotate", "gap", "offset"]))
    ])
  ]))
}